import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface DeviceDocumentsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<DeviceDocumentsServiceData>(db, 'deviceDocumentsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
